<template>
    <div class="h-100 d-none d-md-block hidden">
        <div class="h-100 font-weight-bold pr-0 pl-0 ml-0">
            <div class="dropdown border-left d-none d-md-block h-100" id="recent-tasks-nav-container">
                <!-- For logged out/unregistered user -->
                <a
                    class="bg-white pr-3 pl-3 dropdown-toggle d-flex flex-column h-100 align-items-center justify-content-center fg-normal fg-main-hover fg-main-dropdown-show position-relative font-weight-bold"
                    href="#"
                    role="button"
                    data-toggle="tooltip"
                    :data-original-title="bubbleSpeechText"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-if="!isUserRegistered"
                >
                    <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M25.0943 13.7864V5.45455C25.0943 4.73123 24.8069 4.03754 24.2955 3.52607C23.784 3.01461 23.0903 2.72727 22.367 2.72727H16.667C16.0943 1.14545 14.5943 0 12.8216 0C11.0488 0 9.54882 1.14545 8.9761 2.72727H3.2761C1.7761 2.72727 0.548828 3.95455 0.548828 5.45455V24.5455C0.548828 25.2688 0.836165 25.9625 1.34763 26.4739C1.85909 26.9854 2.55278 27.2727 3.2761 27.2727H11.6079C13.3261 28.9636 15.6715 30 18.2761 30C23.5534 30 27.8215 25.7318 27.8215 20.4545C27.8215 17.85 26.7852 15.5045 25.0943 13.7864ZM12.8216 2.72727C13.5715 2.72727 14.1852 3.34091 14.1852 4.09091C14.1852 4.84091 13.5715 5.45455 12.8216 5.45455C12.0716 5.45455 11.4579 4.84091 11.4579 4.09091C11.4579 3.34091 12.0716 2.72727 12.8216 2.72727ZM3.2761 24.5455V5.45455H6.00337V8.18182H19.6397V5.45455H22.367V11.8364C20.5883 10.9913 18.5916 10.7174 16.6511 11.0524C14.7105 11.3873 12.9212 12.3147 11.5287 13.7072C10.1362 15.0996 9.20888 16.889 8.87392 18.8295C8.53896 20.7701 8.81282 22.7668 9.65792 24.5455H3.2761ZM18.2761 27.2727C14.5125 27.2727 11.4579 24.2182 11.4579 20.4545C11.4579 16.6909 14.5125 13.6364 18.2761 13.6364C22.0397 13.6364 25.0943 16.6909 25.0943 20.4545C25.0943 24.2182 22.0397 27.2727 18.2761 27.2727ZM18.9579 20.7955L22.8579 23.1L21.8352 24.7636L16.9125 21.8182V15H18.9579V20.7955Z"
                            fill="#000"
                            fill-opacity="0.5"
                        />
                    </svg>
                </a>

                <!-- For logged in user -->
                <a
                    class="bg-white pr-3 pl-3 dropdown-toggle d-flex flex-column h-100 align-items-center justify-content-center fg-normal fg-main-hover fg-main-dropdown-show position-relative font-weight-bold"
                    href="#"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-if="isUserRegistered"
                >
                    <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M25.0943 13.7864V5.45455C25.0943 4.73123 24.8069 4.03754 24.2955 3.52607C23.784 3.01461 23.0903 2.72727 22.367 2.72727H16.667C16.0943 1.14545 14.5943 0 12.8216 0C11.0488 0 9.54882 1.14545 8.9761 2.72727H3.2761C1.7761 2.72727 0.548828 3.95455 0.548828 5.45455V24.5455C0.548828 25.2688 0.836165 25.9625 1.34763 26.4739C1.85909 26.9854 2.55278 27.2727 3.2761 27.2727H11.6079C13.3261 28.9636 15.6715 30 18.2761 30C23.5534 30 27.8215 25.7318 27.8215 20.4545C27.8215 17.85 26.7852 15.5045 25.0943 13.7864ZM12.8216 2.72727C13.5715 2.72727 14.1852 3.34091 14.1852 4.09091C14.1852 4.84091 13.5715 5.45455 12.8216 5.45455C12.0716 5.45455 11.4579 4.84091 11.4579 4.09091C11.4579 3.34091 12.0716 2.72727 12.8216 2.72727ZM3.2761 24.5455V5.45455H6.00337V8.18182H19.6397V5.45455H22.367V11.8364C20.5883 10.9913 18.5916 10.7174 16.6511 11.0524C14.7105 11.3873 12.9212 12.3147 11.5287 13.7072C10.1362 15.0996 9.20888 16.889 8.87392 18.8295C8.53896 20.7701 8.81282 22.7668 9.65792 24.5455H3.2761ZM18.2761 27.2727C14.5125 27.2727 11.4579 24.2182 11.4579 20.4545C11.4579 16.6909 14.5125 13.6364 18.2761 13.6364C22.0397 13.6364 25.0943 16.6909 25.0943 20.4545C25.0943 24.2182 22.0397 27.2727 18.2761 27.2727ZM18.9579 20.7955L22.8579 23.1L21.8352 24.7636L16.9125 21.8182V15H18.9579V20.7955Z"
                            fill="currentColor"
                        />
                    </svg>
                </a>
                <div
                    v-if="isUserRegistered"
                    class="main-language-dropdown dropdown-menu dropdown-menu-right dropdown-menu-hover w-100 bg-white p-3 border"
                    id="recent-tasks-nav-drop-down"
                >
                    <!-- DROPDOWN SECTION -->
                    <div>
                        <div>
                            <p>{{ 'Recent Tasks' | trans }}</p>
                            <div v-if="tasks.length > 0">
                                <a
                                    v-for="(task, index) in this.tasks"
                                    :key="index"
                                    class="px-2 br-4 d-flex justify-content-between align-items-center single-task-container"
                                    v-if="index <= 4"
                                    :href="getJobUrl(task.id)"
                                    @click="handleReload(task.id)"
                                >
                                    <div class="d-flex align-items-center">
                                        <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 14 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M6.66667 12.3333C8.08115 12.3333 9.43771 11.7713 10.4379 10.7712C11.4381 9.77096 12 8.41441 12 6.99992C12 5.58543 11.4381 4.22888 10.4379 3.22868C9.43771 2.22849 8.08115 1.66659 6.66667 1.66659C5.25218 1.66659 3.89562 2.22849 2.89543 3.22868C1.89524 4.22888 1.33333 5.58543 1.33333 6.99992C1.33333 8.41441 1.89524 9.77096 2.89543 10.7712C3.89562 11.7713 5.25218 12.3333 6.66667 12.3333ZM6.66667 0.333252C7.54215 0.333252 8.40905 0.50569 9.21789 0.840722C10.0267 1.17575 10.7617 1.66682 11.3807 2.28587C11.9998 2.90493 12.4908 3.63986 12.8259 4.4487C13.1609 5.25753 13.3333 6.12444 13.3333 6.99992C13.3333 8.76803 12.631 10.4637 11.3807 11.714C10.1305 12.9642 8.43478 13.6666 6.66667 13.6666C2.98 13.6666 0 10.6666 0 6.99992C0 5.23181 0.702379 3.53612 1.95262 2.28587C3.20286 1.03563 4.89856 0.333252 6.66667 0.333252ZM7 3.66659V7.16659L10 8.94659L9.5 9.76659L6 7.66659V3.66659H7Z"
                                                fill="black"
                                            />
                                        </svg>
                                        <span class="mr-2 m-l-5">{{ task.created_at | formatTime(userLocale) }}</span>

                                        <span
                                            v-if="task.sat.operation_icon.includes('<')"
                                            v-html="task.sat.operation_icon"
                                            :class="
                                                'mr-1 icon-30 d-inline-flex align-items-center justify-content-center rounded fg-white p-2 bg-main-' +
                                                task.sat.operation_color
                                            "
                                        ></span>
                                        <i
                                            v-else
                                            :class="
                                                'icon-30 d-inline-flex flex-shrink-0 align-items-center justify-content-center mr-1 rounded fg-white far ' +
                                                task.sat.operation_icon +
                                                ' bg-main-' +
                                                task.operation_color
                                            "
                                        ></i>
                                        <span class="m-r-11">{{ translateTaskName(task.sat.readable_operation) }}</span>
                                    </div>
                                    <i v-if="task?.status?.code === 'completed'" class="far fa-check"> </i>
                                    <i
                                        v-if="task?.status?.code === 'processing'"
                                        class="fa fa-spin btn-loading-animation lh-small"
                                    >
                                    </i>
                                    <i v-if="task?.status?.code === 'failed'" class="fa fa-times"> </i>
                                </a>
                            </div>
                            <!-- No Tasks -->
                            <div v-else class="alert-info px-3 br-4 d-flex align-items-center no-task-container">
                                <span>{{ 'No Recent Task' | trans }}</span>
                            </div>
                            <a :href="linkRecentTasks" class="btn w-100 mt-4 all-tasks-btn text-white">
                                <span class="font-weight-bold">{{ 'All Tasks' | trans }}</span>
                                <i class="fa fa-arrow-right lh-inherit ml-1 py-1"></i
                            ></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { apiRequestManager } from '../../../../lib-sat/api/api-request-manager';
import { userManager } from '../../../../lib-sat/user/user-manager';
import { globalLogger } from '../../../helper/global-logger';
import { translate } from '../../../helper/translate';
import { satGlobals } from '../../../sat/helper/sat-globals';
import { translatePath } from '../../../sat/helper/translate-path';
import TransFilter from './mixins/TransFilter.vue';
import FormatDate from './mixins/FormatDate.vue';
import { EVENT_JOB_CANCEL } from './result_v2/events/job.events';
import { EventBus } from './result_v2/events/event.bus';

export default {
    name: 'RecentTasksDropdown',
    mixins: [TransFilter, FormatDate],
    data: function () {
        return {
            tasks: [],
            isUserRegistered: false,
            notRegisteredText: null,
            userLocale: null,
        };
    },
    methods: {
        async getJobHistory() {
            const data = {
                creditJobs: false,
                recentJobs: true,
                excludeSystemJobs: true,
                page: 1,
            };

            try {
                const response = await apiRequestManager.get('/api/users/jobs', data);

                this.tasks = response.data.records.filter(task => task.status.code !== 'incomplete' && task.status.code !== 'cancelled');
            } catch (error) {
                globalLogger.log(error);
            }
        },
        translateTaskName(task) {
            return translate(task);
        },
        getJobUrl(jobId) {
            return satGlobals.getResultUrl() + '#j=' + jobId;
        },
        async handleShow() {
            const user = await userManager.getUser();
            if (user.isRegistered()) {
                this.isUserRegistered = true;
                this.getJobHistory();
            } else {
                this.notRegisteredText = translate('Please log in or sign up to see your recent tasks.');
            }
        },
        //when you click on a recent task while on the result page
        //only the jobId changes, this doesn't reload the page and the new job isn't shown
        //This ensure the page reloads and the new job shown
        handleReload(jobId) {
            const url = window.location.href;
            if (url.includes('result')) {
                window.location.href = this.getJobUrl(jobId);
                window.location.reload();
            }
        },
        async getUserLocale() {
            const user = await userManager.getUser();
            const profile = user.getUserProfile();
            const language = user.getLanguage();
            let country = null;

            profile?.map((data) => {
                if (data.data_key === 'country') {
                    if (data.data_value && data.data_value.length > 0) {
                        country = data.data_value;
                    }
                }
            });

            if (country) {
                this.userLocale = `${language}-${country}`;
            }
        },
    },
    computed: {
        linkRecentTasks() {
            return satGlobals.getAccountUrl() + translatePath('/user/tasks');
        },
        bubbleSpeechText: function () {
            return this.notRegisteredText;
        },
    },
    mounted() {
        this.getUserLocale();
        this.handleShow();
        EventBus.$on(EVENT_JOB_CANCEL, (error) => {
            this.handleShow();
        });
        // when js loads remove placeholder icon
        // placeholder icon was added to ensure the page doesn't jump after js loads
        document.getElementById('recent-tasks-placeholder-icon').classList.remove('d-md-block');
    },
};
</script>
<style scoped>
.single-task-container {
    height: 44px;
    cursor: pointer;
    font-weight: 400;
}
.no-task-container {
    height: 44px;
    font-weight: 400;
}
.single-task-container:hover {
    background-color: #e9ecef;
}
.m-l-5 {
    margin-left: 5px;
}
.m-r-11 {
    margin-right: 11px;
}
#recent-tasks-nav-container {
    z-index: 1;
}
#recent-tasks-nav-drop-down {
    z-index: -1;
    margin-top: -1px;
}

.fa-check {
    color: #0b7335;
}
.fa-times {
    color: #8f2e2e;
}
.all-tasks-btn {
    background: #1266f1;
    &:hover {
        background: #1161e5;
    }
}
.btn-loading-animation {
    border: 2px solid #2e2e2e;
    border-right-color: transparent;
}
</style>
